"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const design_system_1 = require("@zapier/design-system");
const buttonStyles = {
    minWidth: 'fit-content',
};
const StepCardEditButton = () => (common_utils_1.isolateComponent("div", { css: buttonStyles },
    common_utils_1.isolateComponent(design_system_1.Button, { color: "white" }, "Edit")));
exports.default = StepCardEditButton;
